module.exports = __webpack_public_path__ + "img/seo-agency-light.65a2412b.png";